import VueCompositionApi from '@vue/composition-api';
import Vue from 'vue';

Vue.use(VueCompositionApi);
